<template>
  <div class="LargeCopy">
    <BaseHeading
      class="LargeCopy__title"
      tag="h4"
      size="h1"
    >
      {{ copy }}
    </BaseHeading>

    <BaseCopy
      v-if="smallCopy"
      class="LargeCopy__subtitle"
      size="h4"
    >
      {{ smallCopy }}
    </BaseCopy>
  </div>
</template>

<script>
export default {
  name: 'LargeCopy',

  props: {
    copy: {
      type: String,
      required: true
    },
    smallCopy: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="postcss">
.LargeCopy__subtitle {
  @apply mt-xxs
    sm:mb-sm;
}
</style>
